import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ContentWrapper from '../content_wrapper/ContentWrapper';
import InputMask from '../input_mask/InputMask';
import { Icon, Switch, Input, Button, Select, message } from 'antd';
import { DatePicker, Radio } from 'antd';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import { CONTACTS_GROUPS_RESOURCE_NAME, CONTACTS_RESOURCE_NAME } from '../../config/constants';
import { ApiError } from '../../utils/errors';
import { _callResource } from '../../context/_callResource';
import TEXTS from '../../locale/texts';

const { TextArea } = Input;

class NewContact extends Component {
  state = {
    PAYLOAD: {
      id: null,
      bin: '',
      msisdn: null,
      firstname: '',
      middlename: '',
      lastname: '',
      gender: 'M',
      city: '',
      email: '',
      birthDate: '',
      wishBirthday: false,
      note: '',
      inBlackList: false,
      groupIds: []
    },
    groups: null,
    chosenGroups: null,
    day: null,
    contactCreated: false,
    error: false,
    errorMessage: null,
    message: '',
    isLoading: false,
    isEdit: !!this.props.match.path.match(/edit/),
    createContactsIsLoading: false,
    createContactsError: null,
    updateContactsIsLoading: false,
    updateContactsError: null
  };

  callResource = _callResource.bind(this);
  msisdnInput = React.createRef();

  getContactData = () => {
    const { slug, promiseCancelToken } = this.props;
    this.callResource({
      resourceName: CONTACTS_RESOURCE_NAME,
      apiClassName: 'contacts',
      action: 'getOneOf',
      apiCallParams: { id: slug.split('_')[1] },
      promiseCancelToken,
      onSuccess: (response) => {
        this.setState({
          PAYLOAD: response.data,
          day: response.data.birthDate ? moment(response.data.birthDate) : null
        });
      }
    });
  };

  componentDidMount() {
    console.log('mount');
    // todo: fix the error here on mount!
    // Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate.
    // React limits the number of nested updates to prevent infinite loops.
    const { match, location } = this.props;
    window.scrollTo(0, 198);

    const { promiseCancelToken } = this.props;
    // this.setState({ selectedRows: [] });

    this.callResource({
      resourceName: CONTACTS_GROUPS_RESOURCE_NAME,
      apiClassName: 'contactsGroups',
      action: 'get',
      promiseCancelToken,
      onSuccess: (response) => {
        const groups = response.data.items && response.data.items.map((item, i) => {
          return <Select.Option key={i} value={item.id}>{item.name}</Select.Option>;
        });
        this.setState({ groups });
      }
    });

    if (match.path.match(/edit/)) {
      if (location.state) {
        this.setState({
          PAYLOAD: location.state,
          day: location.state.birthDate ? moment(location.state.birthDate) : null
        });
      } else {
        this.getContactData();
      }
    }

    setTimeout(() => {
      this.msisdnInput.current.focus();
    }, 0);
  };

  // CREATE NEW CONTACT
  createNewContact = () => {
    const { promiseCancelToken, addNotification, lang } = this.props;
    const { PAYLOAD } = this.state;
    this.callResource({
      resourceName: CONTACTS_RESOURCE_NAME,
      apiClassName: 'contacts',
      action: 'create',
      apiCallParams: PAYLOAD,
      promiseCancelToken,
      onSuccess: () => {
        addNotification(TEXTS.contactIsCreated[lang]);
        this.toAllContacts();
      },
      onError: (err) => {
        const { errorMessage } = new ApiError(err);
        message.error(`${TEXTS.contactWasNotCreated[lang]}: ${errorMessage}.`, 5);
      }
    });
  };

  // EDIT AND SAVE CONTACT
  updateContact = () => {
    const { promiseCancelToken, addNotification, lang } = this.props;
    const { PAYLOAD } = this.state;
    this.callResource({
      resourceName: CONTACTS_RESOURCE_NAME,
      apiClassName: 'contacts',
      action: 'update',
      apiCallParams: PAYLOAD,
      promiseCancelToken,
      onSuccess: () => {
        addNotification(TEXTS.contactIsSaved[lang]);
        this.toContactsDetails(this.props.slug);
      },
      onError: (err) => {
        const { errorMessage } = new ApiError(err);
        message.error(`${TEXTS.contactWasNotSaved[lang]}: ${errorMessage}`, 5);
      }
    });
  };

  toAllContacts = () => {
    this.props.history.push('/phonebook/contacts');
  };

  toContactsDetails = (slug) => {
    this.props.history.push(`/phonebook/contacts/${slug}`);
  };

  onInputChange = (key, value) => {
    this.setState(state => ({
      PAYLOAD: {
        ...state.PAYLOAD,
        [key]: value
      },
      message: ''
    }));
  };

  onMsisdnChange = (event) => {
    const msisdnValue = event.target.value.replace(/\D/g, '');
    this.setState(state => ({
      PAYLOAD: {
        ...state.PAYLOAD,
        msisdn: msisdnValue
      },
      message: ''
    }));
  };

  onDateChange = (date) => {
    let birthDate = null;
    if (date) {
      const sendYear = date._d.getFullYear();
      const sendMonth = ('0' + (date._d.getMonth() + 1)).slice(-2);
      const sendDay = date._d.getDate();
      birthDate = sendYear + '-' + sendMonth + '-' + (`${sendDay}`.length === 1 ? `0${sendDay}` : sendDay);
    }

    this.setState(state => ({
      PAYLOAD: {
        ...state.PAYLOAD,
        birthDate: birthDate
      },
      message: '',
      day: date
    }));
  };

  onChangeGender = e => {
    this.setState(state => ({
      PAYLOAD: {
        ...state.PAYLOAD,
        gender: e.target.value
      },
      message: ''
    }));
  };

  onWishBirthday = (checked) => {
    this.setState(prevState => ({
      PAYLOAD: {
        ...prevState.PAYLOAD,
        wishBirthday: checked
      }
    }));
  };

  onBlackList = (checked) => {
    this.setState(prevState => ({
      PAYLOAD: {
        ...prevState.PAYLOAD,
        inBlackList: checked
      }
    }));
  };

  handleChangeSelectGroup = (groupIds) => {
    this.setState(state => ({
      PAYLOAD: { ...state.PAYLOAD, groupIds }
    }));
  };

  render() {
    const { lang } = this.props;
    const {
      PAYLOAD,
      day,
      error,
      errorMessage,
      isLoading,
      isEdit,
      groups,
      createContactsIsLoading,
      updateContactsIsLoading
    } = this.state;
    const {
      msisdn,
      firstname,
      middlename,
      lastname,
      gender,
      city,
      email,
      wishBirthday,
      note,
      groupIds
    } = PAYLOAD;

    const saveContactIsLoading = createContactsIsLoading || updateContactsIsLoading;

    return (
      <ContentWrapper>
        <h4 className="form-row title text-pink text-uppercase mb-4">
          {isEdit ? TEXTS.editContactTitle[lang] : TEXTS.crateContactTitle[lang]}
        </h4>
        <div>
          <div className="form-row mb-3">
            <div style={{ width: '100%' }}>
              <label className="t-bold">
                {TEXTS.contactPhoneLabel[lang]}
                <span className="star-required text-pink">*</span>
              </label>
              <InputMask
                _ref={this.msisdnInput}
                onChange={this.onMsisdnChange}
                mask="+7-999-999-99-99"
                value={msisdn}
              />
            </div>
          </div>
          <div className="form-row schedule-time mb-4 flex-direction-column">
            <div className="d-flex align-items-center">
              <label className="mr-2 mb-0 t-bold">{TEXTS.btnBlackListAdd[lang]}</label>
              <Switch
                checked={PAYLOAD.inBlackList}
                onChange={this.onBlackList}
              />
            </div>
          </div>
          <div className="form-row mb-4">
            <div style={{ width: '100%' }}>
              <label className="t-bold">
                {TEXTS.contactGroupsLabel[lang]}
              </label>
              <Select
                mode="multiple"
                style={{ width: '100%' }}
                size="large"
                placeholder={TEXTS.contactGroupsPlaceholder[lang]}
                value={groupIds}
                onChange={this.handleChangeSelectGroup}
              >
                {groups}
              </Select>
            </div>
          </div>
          <div className="form-row mb-4">
            <label className="t-bold">
              {TEXTS.contactNameLabel[lang]}
            </label>
            <Input
              size="large"
              name="firstname"
              placeholder={TEXTS.contactNameLabel[lang]}
              value={firstname}
              maxLength="30"
              onChange={({ target: { name, value } }) =>
                this.onInputChange(name, value)
              }
            />
          </div>
          <div className="form-row mb-4">
            <label className="t-bold">
              {TEXTS.contactSecondNameLabel[lang]}
            </label>
            <Input
              size="large"
              name="lastname"
              value={lastname}
              maxLength="30"
              placeholder={TEXTS.contactSecondNameLabel[lang]}
              onChange={({ target: { name, value } }) =>
                this.onInputChange(name, value)
              }
            />
          </div>
          <div className="form-row mb-4">
            <label className="t-bold">
              {TEXTS.contactMiddleNameLabel[lang]}
            </label>
            <Input
              size="large"
              name="middlename"
              value={middlename}
              maxLength="30"
              placeholder={TEXTS.contactMiddleNameLabel[lang]}
              onChange={({ target: { name, value } }) =>
                this.onInputChange(name, value)
              }
            />
          </div>
          <div className="form-row schedule-time mb-4 flex-direction-column">
            <label>{TEXTS.birthDate[lang]}</label>
            <div className="d-flex align-items-center">
              <DatePicker
                className='mr-3'
                size='large'
                value={day}
                placeholder={TEXTS.birthDate[lang]}
                format='DD-MM-YYYY'
                onChange={this.onDateChange}
              />
              {/*<div className='ml-2'>*/}
              {/*<label className='mr-2'>Отправлять поздравления</label>*/}
              {/*<Switch*/}
              {/*checked={wishBirthday}*/}
              {/*onChange={this.onWishBirthday}*/}
              {/*/>*/}
              {/*</div>*/}
              <div className="ml-2">
                <label className="t-bold  mr-3">{TEXTS.contactGenderLabel[lang]}</label>
                <Radio.Group onChange={this.onChangeGender} value={gender}>
                  <Radio value="M">{TEXTS.contactGenderMale[lang]}</Radio>
                  <Radio value="F">{TEXTS.contactGenderFemale[lang]}</Radio>
                </Radio.Group>
              </div>
            </div>
          </div>
          <div className="form-row mb-4">
            <label className="t-bold">
              Email
            </label>
            <Input
              size="large"
              name="email"
              value={email}
              maxLength="30"
              placeholder="Email"
              onChange={({ target: { name, value } }) =>
                this.onInputChange(name, value)
              }
            />
          </div>
          <div className="form-row mb-4">
            <label className="t-bold">
              {TEXTS.contactCityLabel[lang]}
            </label>
            <Input
              size="large"
              name="city"
              value={city}
              maxLength="30"
              placeholder={TEXTS.contactCityLabel[lang]}
              onChange={({ target: { name, value } }) =>
                this.onInputChange(name, value)
              }
            />
          </div>
          <div className="form-row mb-4">
            <label className="t-bold">{TEXTS.comment[lang]}</label>
            <TextArea
              name="note"
              rows={3}
              value={note}
              maxLength="200"
              placeholder={TEXTS.comment[lang]}
              onChange={({ target: { name, value } }) =>
                this.onInputChange(name, value)
              }
            />
          </div>
          {error
            && <div className={`alert alert-danger mt-3`}>
                 {errorMessage}
               </div>}
          <div className="form-row">
            <Button
              size="large"
              type="primary"
              style={{padding: '0 20px', height: 50, marginRight: 15, fontSize: 16}}
              loading={saveContactIsLoading}
              disabled={saveContactIsLoading || (!PAYLOAD.msisdn || PAYLOAD.msisdn.length < 11)}
              onClick={() => (isEdit ? this.updateContact() : this.createNewContact())}>
              {isEdit ? TEXTS.btnSaveContact[lang] : TEXTS.btnCreateContact[lang]}
            </Button>
            <Button
              size="large"
              style={{padding: '0 20px', height: 50, marginRight: 15, fontSize: 16}}
              loading={isLoading}
              onClick={() => {
                if (isEdit) {
                  this.toContactsDetails(this.props.slug);
                } else {
                  this.toAllContacts();
                }
              }}>
              {TEXTS.btnCancel[lang]}
            </Button>
          </div>
        </div>
      </ContentWrapper>
    );
  }
}

export default withRouter(NewContact);
